import React from "react";
import {Select, Spin} from "antd";
import {HotSheetList} from "../models/hotsheet";

const Option = Select.Option;
const _ = require('lodash');
const moment = require('moment');

export class HotSheetFilter extends React.Component {
  state = {
    visible: false,
    data: [],
    value: [],
    fetching: false
  };
  showDrawer = () => {
    this.setState({
      visible: true
    });
  };
  onClose = () => {
    this.setState({
      visible: false
    });
  };
  fetchHotSheet = () => {
    this.setState({data: [], fetching: true});
    HotSheetList({...this.props.hotsheet_data})
      .then(response => {
        const data = response.data.results.map(type => ({
          text: `${type.hot_sheet_number} | ${_.get(type, 'service.next_service_date')} | ${_.get(type, 'service.waste_data.0.waste_stream.code')} | ${moment(_.get(type, 'service.next_service_date')).format('dddd')}`,
          value: type.id
        }));
        this.setState({data, fetching: false});
        if (response.data.results.length === 1) {
          const first_row = response.data.results[0];
          this.handleChange({
            key: first_row.id,
            label: `${first_row.hot_sheet_number} | ${_.get(first_row, 'service.next_service_date')} | ${moment(_.get(first_row, 'service.next_service_date')).format('dddd')} | ${_.get(first_row, 'service.waste_data.0.waste_stream.code')} `,
          })
        }
      })
  };

  handleChange = (value) => {
    this.setState({
      value,
      fetching: false
    });
    this.props.onChange(value.key);
  };

  componentDidMount() {
    if (this.props.onRef)
      this.props.onRef(this);
  }

  componentWillUnmount() {
    if (this.props.onRef)
      this.props.onRef(null)
  }

  render() {
    const {fetching, data, value} = this.state;
    return (
      <div className="drawer-search-dropdown">
        <Select labelInValue showSearch value={value} dropdownClassName="drawer-select"
                placeholder="Select Business Category" notFoundContent={fetching ? <Spin size="small"/> : "Not Found"}
                filterOption={false} onFocus={this.fetchHotSheet} onSearch={this.fetchHotSheet}
                onChange={this.handleChange} style={{width: "100%"}}>
          {data.map(d => (
            <Option key={d.value}>{d.text}</Option>
          ))}
        </Select>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/filters/HotSheetFilter.jsx